import React, { useState, useEffect, useContext } from 'react';

import { Col, CardTitle, FormGroup } from 'reactstrap';
import UserContext from '../../UserContext';

import { AuthMember, frontend } from '../../../api';
import { UnauthorizedException } from '../../../api/exceptions/UnauthorizedException';
import { useNavigate } from 'react-router-dom';

export const DetailsTab = () => {
	const navigate = useNavigate();
	const { user, setUserCredentials } = useContext(UserContext);
	const [isLoaded, setIsLoaded] = useState(false);
	const [data, setData] = useState<Array<{ name: string; value: string | number }>>([]);

	/**
	 * This function will retrieve the user profile data from the backend
	 */
	useEffect(() => {
		const getContents = async () => {
			try {
				if (user == null) {
					navigate('/app/login');
					return;
				}

				const response = await frontend.getProfile(user.token ?? '');
				setData(response);

				const clearanceAlerts = response.filter((entry) => entry.name === 'clearanceAlerts')[0];
				if (clearanceAlerts) {
					const newUser = { ...user };
					(newUser as AuthMember).clearanceAlerts = clearanceAlerts.value as number;
					setUserCredentials({ access: newUser, refresh: '' });
				}

				setIsLoaded(true);
			} catch (err) {
				if (err instanceof UnauthorizedException) {
					// Redirect to login
					navigate('/app/login');
				} else {
					// TODO: Handle better
					console.error('error');
					console.error(err);
				}
			}
		};

		getContents();
	}, []);

	return (
		<div className="details-tab">
			<CardTitle tag="h4" style={{ marginTop: 0, marginBottom: '.5rem' }}>
				Personal Details
			</CardTitle>
			{!isLoaded ? (
				<>Loading...</>
			) : (
				Object.keys(data)
					.filter((field) => data[field as any].name != 'clearanceAlerts')
					.map((field) => {
						return (
							<FormGroup row key={`member-dashboard-details-tab-field-${field}`}>
								<Col sm={3}>{data[field as any].name}</Col>
								<Col sm={9}>{data[field as any].value}</Col>
							</FormGroup>
						);
					})
			)}
		</div>
	);
};
